export function redirectToLogin() {
  window.location.href = '/login?callbackUrl=' + window.location.pathname;
}
